import { ApiProvidersTable } from "@/features/api-providers/api-providers-table";

export function ApiProvidersScreen() {
  return (
    <div className="p-4">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">API Providers</h1>
        <p className="text-gray-600 mt-2">Manage shipping API providers</p>
      </div>
      <ApiProvidersTable />
    </div>
  );
}
